export default function updatePriceReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'UPDATE_PRICE_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'UPDATE_PRICE_ERROR':
            return {...state, ...{error: action.error}};

        case 'UPDATE_PRICE_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}